import { GITHUB, REPOSITORIES } from "icons";
import IntegrationSidebarLayout from "../components/sidebar-layout";
import IntegrationIconHeader from "../components/icon-header";

// /integrations/github/repositories: GitHub logo header + Repositories tab.
export default function GithubIntegrationLayout() {
  return (
    <IntegrationSidebarLayout
      name="integrations-github"
      header={<IntegrationIconHeader icon={GITHUB} title="Github" />}
      items={[
        { title: "Repositories", icon: REPOSITORIES, url: "/integrations/github/repositories" },
        // { title: "People", icon: "lucide:users", url: "/integrations/github/people" },
      ]}
    />
  );
}
